import React from 'react'
import { SearchIcon } from '../ui-components/Icons'
import SearchBarServices from './SearchBarServices'
import SearchBarSuggestions from './SearchBarSuggestions'
import { ServiceData, TrendingSuggestions } from '../types/types'

type Props = {
  servicesData: ServiceData[]
}

function SearchInlay({servicesData}: Props) {
  return (
    <>
      <div className='text-lg-heading md:text-xxl font-bstSpyre mt-[191px] md-max:px-[30px] md:mt-[171px] text-center'>
        Looking for something more?
      </div>
      <div className='text-base-2 font-bstSpyre tracking-[0.56px] mt-XS text-center md-max:px-[30px]'>
        Explore our services...
      </div>
      <SearchBarServices servicesData={servicesData} />
    </>
  )
}

export default SearchInlay